import { BrandName } from '../../Typescript/index'
import './Logo.css'

const Logo = ({ brandName }: { brandName: BrandName }) => {
    const styleClasses = `brand-logo ${brandName === BrandName.cnbc ? 'cnbc-logo' : 'msnow-logo'}`
    const logoUrl = brandName === BrandName.cnbc ? 'https://www.cnbc.com' : 'https://www.msnbc.com/'
    return (
        <h1>
            <a className={styleClasses} href={logoUrl} />
        </h1>
    )
}

export default Logo
